
// src/utils/FechaHora.js

export default class FechaHora {
    constructor() {
        this.fecha = new Date();
    }

    /**
     * Obtiene la fecha actual en formato YYYY-MM-DD
     * @returns {string}
     */
    getFecha() {
        return `${this.fecha.getFullYear()}-${String(this.fecha.getMonth() + 1).padStart(2, '0')}-${String(this.fecha.getDate()).padStart(2, '0')}`;
    }

    /**
     * Obtiene la hora actual en formato HH:MM:SS
     * @returns {string}
     */
    getHora() {
        return `${String(this.fecha.getHours()).padStart(2, '0')}:${String(this.fecha.getMinutes()).padStart(2, '0')}:${String(this.fecha.getSeconds()).padStart(2, '0')}`;
    }

    /**
     * Obtiene la fecha y hora actual como un objeto
     * @returns {{tcFecha: string, tcHora: string}}
     */
    getFechaHora() {
        return {
            tcFecha: this.getFecha(),
            tcHora: this.getHora(),
        };
    }

    /**
     * Retorna la hora en formato HH-MM-SS (en vez de HH:MM:SS), útil para nombres de archivos.
     * @returns {string}
     */
    getHoraArchivo() {
        return this.getHora().replace(/:/g, '-');
    }
}
